import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { PlantMaster } from 'src/app/shared/models/plant-master';
import { DataService } from 'src/app/shared/services/data-service/data.service';

@Component({
  standalone: false,
  selector: 'plant-input',
  templateUrl: './plant-input.component.html',
  styleUrls: ['./plant-input.component.scss'],
})
export class PlantInputComponent {
  keyword = 'fullName';
  data: PlantMaster[];
  isLoading: boolean;
  @Input() error: string = '';
  @Input() selectedValue: string = '';
  @Output() selectedValueChange = new EventEmitter<string>();
  @ViewChild('auto') auto: any;

  constructor(private dataService: DataService) {}

  selectEvent(item: PlantMaster) {
    this.selectedValue = item.t001W_WERKS_Plant;
    this.selectedValueChange.emit(this.selectedValue);
  }

  async onChangeSearch(val: string) {
    this.selectedValue = val.toUpperCase();
    this.selectedValueChange.emit(this.selectedValue);

    this.isLoading = true;
    this.data = await this.dataService.searchPlant(val.toUpperCase());
    this.isLoading = false;
  }

  onFocused(e: any) {
    // do something when input is focused
  }
}

